import React from 'react';

import ArtworkForm from '../ArtworkForm';

export default function AddArtworkScreen() {
  return <ArtworkForm />;
}
